import { render } from "./telInput.vue?vue&type=template&id=29ff8e53"
import script from "./telInput.vue?vue&type=script&lang=js"
export * from "./telInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__